import { MarketValueTypes } from '../constants/marketValueTypes';
import { IBasketballTournamentProgrammeApi } from '../types';
import Core from '@mediaplatform/basketball-sdk';
import { FIXTURES } from '../constants/programmeStatus';

export default (sdk: Core): IBasketballTournamentProgrammeApi => {
  const getBasketballTournamentProgramme: IBasketballTournamentProgrammeApi['getBasketballTournamentProgramme'] = ({
    filter,
    dataCompetition,
    dataStage = '',
    dataSeason = '',
    dataRoundsFilter = [],
    dataLimit = '',
    dataDateFrom,
    dataDateTo,
    dataOddsDisplay,
    dataOddsBettingId,
    dataSortDirectionFixtures = '',
    dataSortDirectionResults = '',
    dataOddsMarket = '',
    dataOddsPreEventOnly = false,
    dataOddsMarketValueType = MarketValueTypes.DECIMAL,
    signal,
  }) => {
    if (dataCompetition) {
      const tournamentProgramme = sdk.tournamentProgramme({
        competitionId: dataCompetition,
        seasonId: dataSeason,
        stageId: dataRoundsFilter?.length > 0 ? '' : dataStage,
        filterType: filter ? filter.toLowerCase() : '',
        limit: dataLimit ?? '',
        sortDirection: filter === FIXTURES ? dataSortDirectionFixtures : dataSortDirectionResults,
        roundFilter: dataRoundsFilter,
      });

      if (!tournamentProgramme) return;

      if (dataDateFrom || dataDateTo) {
        tournamentProgramme.withDateRange({
          from: dataDateFrom,
          to: dataDateTo,
        });
      }

      if (dataOddsDisplay) {
        tournamentProgramme.withOdds({
          bettingId: dataOddsBettingId ?? '',
          oddFormat: dataOddsMarketValueType.toUpperCase(),
          preEventOddsOnly: dataOddsPreEventOnly,
          market: dataOddsMarket,
        });
      }

      if (dataStage && dataRoundsFilter?.length > 0) {
        console.warn('Filters data-stage and data-rounds-filter cannot be submitted together!');
      }

      if (signal) {
        return tournamentProgramme?.get({ signal });
      } else {
        return tournamentProgramme?.get();
      }
    }

    console.warn('No competition is provided');
  };

  return { getBasketballTournamentProgramme };
};
